export const SortBySeason =  (a , b) => (a.node.seasonClosed === b.node.seasonClosed) ? 0 : a.node.seasonClosed ? 1 : -1;


export const SortBySeason2 = (array) => {
    let seasonClosedArray = array.filter(item => (item.node.seasonClosed));
    let seasonOpenArray = array.filter(item => (!item.node.seasonClosed));
    return seasonClosedArray ? seasonOpenArray.concat(seasonClosedArray) : seasonOpenArray;
}